import { create } from '../createOverridableMock';

import type { AnalyticsSettings } from './types';

export const defaultAnalyticsSettings: AnalyticsSettings = {
  selectedOnBehalfOfUserId: undefined,
  selectedGroupId: undefined,
  selectedCampaignId: undefined,
};

export const createMockAnalyticsSettings: (overrides?: Partial<AnalyticsSettings>) => AnalyticsSettings =
  create<AnalyticsSettings>(defaultAnalyticsSettings);
